//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
export default {
  components: {
    Avatar: Avatar
  },
  methods: {
    containLogin: function containLogin() {
      this.delUrlParams('vuid');
      this.delUrlParams('head');
      this.delUrlParams('nick');
      this.delUrlParams('type');
      this.$emit('close');
    }
  }
};